<style>
@import url("https://fonts.googleapis.com/css2?family=Lora:wght@400;600&display=swap");
.application {
  font-family: "Lora", serif !important;
}
#headerText {
  font-family: "Lora", serif;
  font-weight: 600;
}
</style>

<template>
  <v-app class="background">
    <v-toolbar app class="primary">
      <v-toolbar-title
        class="headline text-uppercase"
        style=" margin-right: 5px;"
      >
        <router-link
          v-if="!!userIsAuthenticated && !!satisfied"
          to="/news"
          tag="span"
          style="cursor: pointer; "
          ><img
          class="hidden-sm-and-down"
            src="./assets/Concord_Logo_Final.webp"
            style="max-height: 55px;padding-top: 7px;"
        />
        <img
          class="hidden-md-and-up"
            src="./assets/smallLogo.webp"
            style="max-height: 55px;padding-top: 7px;"
        /></router-link>
        <div
        v-else>
        <img
          class="hidden-sm-and-down"
          src="./assets/Concord_Logo_Final.webp"
          style="max-height: 5vh;padding-top: 7px;"
        />
        <img
          class="hidden-md-and-up"
            src="./assets/smallLogo.webp"
            style="max-height: 5vh;padding-top: 7px;"
        />
        </div>
        
      </v-toolbar-title>

      <!-- <v-text-field
        label="Search"
        color="white"
        solo
        class="hidden-sm-and-down"
        style="padding: 10px;padding-right: 100px; max-width:600px;"
        append-icon="search"
        v-show="!!userIsAuthenticated && !!satisfied"
        v-model="search"
        @input="change()"
      ></v-text-field> -->

      <v-spacer> </v-spacer>
      <div class="hidden-sm-and-down">
        <div
          style="position: relative; display: initial;"
          @mouseover="hover = true"
          @mouseleave="hover = false"
        >
          <v-btn
            flat
            fab
            dark
            v-show="!!userIsAuthenticated && !!satisfied && !!admin"
            :to="{ name: 'createpost' }"
            style="border-radius: 25px;"
          >
            <v-icon dark style=" font-size:40px; color: #f1ce3e !important;"
              >library_add</v-icon
            >
          </v-btn>
          <span
            v-show="hover"
            class="upvote titles--text"
            style=" color: white; text-align: center; border-radius: 6px; position: absolute; padding: 5px 0px; width: 100px; top:  300%; left: -20%;"
          >
            Create Post</span
          >
        </div>
        <div
          style="position: relative; display: initial;"
          @mouseover="hover6 = true"
          @mouseleave="hover6 = false"
        >
          <v-btn
            flat
            fab
            dark
            v-show="!!userIsAuthenticated && !!satisfied"
            :to="{ name: 'suggestion' }"
            style="border-radius: 25px;"
          >
            <v-icon dark style=" font-size:40px; color: #f1ce3e !important;"
              >tips_and_updates</v-icon
            >
          </v-btn>
          <span
            v-show="hover6"
            class="upvote titles--text"
            style=" color: white; text-align: center; border-radius: 6px; position: absolute; padding: 5px 0px; width: 100px; top:  300%; left: -20%;"
          >
            Suggest Post</span
          >
        </div>

        <v-btn
          flat
          v-show="!!userIsAuthenticated && !satisfied && !!done"
          :to="links"
          class="danger"
          style="border-radius: 25px;"
        >
          <span style="color:white;">Fill Out Your Profile to Explore</span>
        </v-btn>
        <div
          style="position: relative; display: initial;"
          @mouseover="hover4 = true"
          @mouseleave="hover4 = false"
        >
          <v-btn
            flat
            fab
            dark
            v-show="!!userIsAuthenticated && !!satisfied"
            :to="{ name: 'news' }"
            style="border-radius: 25px;"
          >
            <v-icon dark style=" font-size:40px; ">home</v-icon>
          </v-btn>
          <span
            v-show="hover4"
            class="titles"
            style="
                color: white;
                text-align: center;
                border-radius: 6px;
                position: absolute;
                padding: 5px 0px;
                width: 100px;
                top:  300%;
                left: -20%;"
          >
            Home
          </span>
        </div>
        <div
          style="position: relative; display: initial;"
          @mouseover="hover3 = true"
          @mouseleave="hover3 = false"
        >
          <v-btn
            flat
            fab
            dark
            v-show="!!userIsAuthenticated && !!satisfied"
            :to="{ name: 'searchBlank' }"
            style="border-radius: 25px;"
          >
            <v-icon dark style=" font-size:40px; ">search</v-icon>
          </v-btn>
          <span
            v-show="hover3"
            class="titles"
            style="
                color: white;
                text-align: center;
                border-radius: 6px;
                position: absolute;
                padding: 5px 0px;
                width: 100px;
                top:  300%;
                left: -20%;"
          >
            Search</span
          >
        </div>

        <!-- <div style="position: relative; display: initial;" @mouseover="hover1 = true" @mouseleave="hover1 = false">
                <v-btn flat fab dark v-show="!!userIsAuthenticated && !!satisfied && !!admin" :to="{name: 'news_review'}" style="border-radius: 25px;">
                    <v-icon dark style=" font-size:40px; ">rate_review</v-icon>
                </v-btn>
                <span v-show="hover1" class="titles" style="
            color: white;
            text-align: center;
            border-radius: 6px;
            position: absolute;
            padding: 5px 0px;
            width: 100px;
            top:  300%;
            left: -20%;"> Review Posts</span>
            </div> -->
        <div
          style="position: relative; display: initial;"
          @mouseover="hover2 = true"
          @mouseleave="hover2 = false"
        >
          <v-btn
            flat
            fab
            dark
            v-show="!!userIsAuthenticated"
            :to="links"
            style="border-radius: 25px;"
          >
            <v-icon dark style=" font-size:40px; ">person</v-icon>
          </v-btn>
          <span
            v-show="hover2"
            class="titles"
            style="
                color: white;
                text-align: center;
                border-radius: 6px;
                position: absolute;
                padding: 5px 0px;
                width: 100px;
                top:  300%;
                left: -20%;"
          >
            Profile</span
          >
        </div>
      </div>

      <v-toolbar-side-icon
        dark
        class="hidden-md-and-up"
        v-show="userIsAuthenticated"
        @click="sideNav = true"
      ></v-toolbar-side-icon>
      <v-btn
        class="primary"
        flat
        v-show="!userIsAuthenticated && !home && ($route.name == 'news_share' || $route.name == 'ForgotPassword' || $route.name == 'signup')"
        :to="{ name: 'prehome' }"
        style="border-radius: 25px;  "
      >
        <span style="color:white;">Sign In</span>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer
      fixed
      temporary
      right
      v-model="sideNav"
      style="width:fit-content; background:  #a3a6a2"
    >
      <v-btn
        text
        @click="sideNav = false"
        fab
        small
        flat
        style="background-color: grey;margin:15px;float: right; "
      >
        <v-icon dark flat style="font-size:20px; color:white; ">close</v-icon>
      </v-btn>
      <v-list style="padding:3px; clear:both" v-model="group">
        <v-list-tile
          flat
          fab
          v-show="!!userIsAuthenticated && !!satisfied && !!admin"
          :to="{ name: 'createpost' }"
          class="upvote"
          style="margin:5px;border-radius: 10px; height: fit-content; padding: 4px;"
        >
          <v-icon dark style=" font-size:40px; ">library_add</v-icon>
        </v-list-tile>
        <v-list-tile
          flat
          fab
          v-show="!!userIsAuthenticated && !!satisfied"
          :to="{ name: 'suggestion' }"
          class="upvote"
          style="margin:5px;border-radius: 10px; height: fit-content; padding: 4px;"
        >
          <v-icon dark style=" font-size:40px; ">tips_and_updates</v-icon>
        </v-list-tile>
        <v-list-tile
          flat
          fab
          v-show="!!userIsAuthenticated && !satisfied && !!done"
          :to="links"
          class="danger"
          style="margin:5px;border-radius: 10px; height: fit-content; padding: 4px;"
        >
          <span style="color:white;">Fill Out Your Profile to Explore</span>
        </v-list-tile>

        <v-list-tile
          flat
          fab
          v-show="!!userIsAuthenticated && !!satisfied"
          :to="{ name: 'news' }"
          class="primary"
          style="margin:5px;border-radius: 10px; height: fit-content; padding: 4px;"
        >
          <v-icon dark style=" font-size:40px; ">home</v-icon>
        </v-list-tile>

        <v-list-tile
          flat
          fab
          v-show="!!userIsAuthenticated && !!satisfied"
          :to="{ name: 'searchBlank' }"
          class="primary"
          style="margin:5px;border-radius: 10px; height: fit-content; padding: 4px;"
        >
          <v-icon dark style=" font-size:40px; ">search</v-icon>
        </v-list-tile>
        <v-list-tile
          flat
          fab
          v-show="!!userIsAuthenticated"
          :to="links"
          class="primary"
          style=" margin:5px;border-radius: 10px; height: fit-content; padding: 4px;"
        >
          <v-icon dark style=" font-size:40px; ">person</v-icon>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      fab
      dark
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
      class="hidden-sm-and-down"
    >
      <v-icon>keyboard_arrow_up</v-icon>
    </v-btn>
    <v-content
      class="px-0 bumpContent"
      style="align-self: center; max-width: 1380px;  width: -webkit-fill-available;"
      @satisfy="(satisfied = true), (id = true)"
    >
      <router-view
        @satisfy="(satisfied = true), (id = true)"
        style="height: 100%; margin-bottom: 150px;"
      ></router-view>
      <div class="footer-basic primary elevation-4">
        <footer>
          <ul class="list-inline">
            <li class="list-inline-item"><a href="#">Terms</a></li>
            <li class="list-inline-item"><a href="#">Privacy Policy</a></li>
            <li class="list-inline-item"><a href="#">Site Map</a></li>
          </ul>
          <p class="copyright">
            (Not Setup Yet) <br>
            Concord Report LLC. © 2021
            <!-- <br />Developed and Designed by
            <a href="https://devincraig.info">Devin Craig</a>. -->
          </p>
        </footer>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import { mapState } from "vuex";

export default {
  metaInfo() {
    return {
      title: "The Concord Report - A Community Built by Individuals",
      meta: [
        {
          name: "description",
          content:
            "The Concord Report keeps you updated on current events by transforming the way articles are presented. The Concord Report is a non-partisan, digestable news source and discussion eccosystem for everyone.",
        },
        {
          property: "og:title",
          content: "The Concord Report - A Community Built by Individuals",
        },
        { property: "og:site_name", content: "The Concord Report" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
  data() {
    return {
      id: false,
      link: "/",
      admin: false,
      search: "",
      menu: false,
      sideNav: false,
      userIsAuthenticated: false,
      satisfied: false,
      done: false,
      hover: false,
      hover1: false,
      hover2: false,
      hover3: false,
      hover4: false,
      hover6: false,
      home: true,
      fab: false,
      group: null
    };
  },
  computed: {
    ...mapState(["user", "userProfile"]),
    links() {
      var link = "/";
      if (this.userIsAuthenticated) {
        link = "/profile/" + this.$store.getters.user.uid;
      }
      return link;
    },
  },
  mounted: function() {
    var self = this;
    setTimeout(function() {
      try {
        (self.id = self.userProfile.profile),
          (self.admin = self.userProfile.isAdmin);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log("not logged in");
      }
    }, 2000);
    if (this.$route.name === "prehome") {
      this.home = true;
    } else {
      this.home = false;
    }
  },
  watch: {
    $route(to, from) {
      var self = this;
      if (
        to !== from &&
        (this.$route.name === "news" || this.$route.name === "search")
      ) {
        self.search = this.$route.params.id;
      }
      if (this.$route.fullPath === "/search/") {
        self.search = "";
      }
      if (
        self.search != "" &&
        !(this.$route.name === "news" || this.$route.name === "search")
      ) {
        self.search = "";
      }
      if (this.$route.name === "prehome") {
        this.home = true;
      } else {
        this.home = false;
      }
    },
    userIsAuthenticated() {
      var self = this;
      (self.id = self.userProfile.profile),
        (self.admin = self.userProfile.isAdmin);
      if (self.userIsAuthenticated && self.id) {
        self.satisfied = self.id;
        self.done = true;
      } else {
        self.satisfied = false;
        self.done = true;
      }

      this.$forceUpdate();
    },
    userProfile() {
      var self = this;
      (self.id = self.userProfile.profile),
        (self.admin = self.userProfile.isAdmin),
        (self.userIsAuthenticated = true);
      if (self.userIsAuthenticated && self.id) {
        self.satisfied = self.id;
        self.done = true;
      } else {
        self.satisfied = false;
        self.done = true;
      }

      this.$forceUpdate();
    },
  },
  methods: {
    change() {
      this.$router.push("/search/" + this.search);
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
  created: function() {
    var self = this;
    setInterval(function() {
      self.userIsAuthenticated =
        self.$store.getters.user !== null &&
        self.$store.getters.user !== undefined;

      if (self.userIsAuthenticated && self.id) {
        self.satisfied = self.id;
        self.done = true;
      } else {
        self.satisfied = false;
        self.done = true;
      }
    }, 3000);
  },
};
</script>

<style lang="scss">
@import "assets/main.scss";
</style>
